import React from 'react';
import Tile from '../Tile';
import { useStore } from '../../store';
import { useUncategorizedTransactionsQuery } from '../../hooks/query/useUncategorizedTransactionsQuery';
import { DOCS_AREA_NO_DATA_MESSAGE } from '../../constants/general';

interface IProps {
  year: number;
  docs: any[];
  expenses: boolean;
  uncategorizedQuarters?: string[];
  title?: string;
}

const DocsArea = ({ year, docs, uncategorizedQuarters, expenses, title }: IProps) => {
  const { customerId } = useStore((state) => state.currUser());
  const uncategorizedTransactions = useUncategorizedTransactionsQuery({
    customerId,
    query: uncategorizedQuarters || [],
    isExpenses: expenses,
  });
  const {
    CURRENT_YEAR_NO_STATEMENTS,
    CURRENT_YEAR_NO_REPORTS,
    NOT_CURRENT_YEAR_NO_STATEMENTS,
    NOT_CURRENT_YEAR_NO_REPORTS,
  } = DOCS_AREA_NO_DATA_MESSAGE;
  const setMessage = (yearParam: number, expensesParam: boolean) => {
    switch (true) {
      case yearParam === new Date().getFullYear() && !expensesParam:
        return CURRENT_YEAR_NO_STATEMENTS;
      case yearParam === new Date().getFullYear() && expensesParam:
        return CURRENT_YEAR_NO_REPORTS;
      case yearParam !== new Date().getFullYear() && !expensesParam:
        return NOT_CURRENT_YEAR_NO_STATEMENTS;
      case yearParam !== new Date().getFullYear() && expensesParam:
        return NOT_CURRENT_YEAR_NO_REPORTS;
      default:
        return '';
    }
  };

  return (
    <div className='w-full h-full' id='docsArea'>
      {docs && !!docs.length && (
        <div className='sticky top-0'>
          <h1 id='currentYear' className='text-[1.25rem] leading-[2.1rem] text-bw08 font-metricMedium'>
            {title ?? year}
          </h1>
          <div className='h-0 border-t border-bw05 mt-2 opacity-50' />
        </div>
      )}
      <div
        className={
          docs && docs.length > 0
            ? 'flex flex-wrap mt-6 gap-x-[1.875rem] gap-y-4 overflow-y-auto max-h-[90%]'
            : 'flex justify-center'
        }
      >
        {docs && docs.length > 0 ? (
          docs.map((doc: any, index) => (
            <React.Fragment key={`doc${doc.externalId}`}>
              <Tile
                tileIndex={index}
                id={`tile${index}`}
                key={doc.externalId ?? `tile${index}`}
                expenseObj={expenses ? doc : null}
                statementObj={expenses ? null : doc}
                uncategorizedTransactions={uncategorizedTransactions[index]?.data}
              />
            </React.Fragment>
          ))
        ) : (
          <div id='noDataMessage' className='mt-[20vh] font-medium text-base text-bw07'>
            {setMessage(year, expenses)}
          </div>
        )}
      </div>
    </div>
  );
};
export default DocsArea;
